import { NgIf } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatToolbar } from '@angular/material/toolbar';
import { RouterLink } from '@angular/router';
import { BackendFullSizeDto, School } from '@tanzspass/shared';
import { environment } from '../../../environments/environment';
import { CourseToolbarMenuComponent } from '../../course/course-toolbar-menu/course-toolbar-menu.component';
import { AuthService } from '../../services/auth.service';
import { BackendService } from '../../services/backend.service';
import { SchoolService } from '../../services/school.service';
import { TimeService } from '../../services/time.service';

@Component({
  selector: 'ts-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css'],
  imports: [
    MatToolbar,
    MatIcon,
    RouterLink,
    CourseToolbarMenuComponent,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    NgIf,
  ],
})
export class ToolbarComponent implements OnInit {
  @Output() toggledSidebar = new EventEmitter<boolean>();

  public backends: BackendFullSizeDto<any>[];
  public school: School = new School();
  public now: number = TimeService.now.getFullYear();
  isAuthenticated = false;
  environment = environment;

  constructor(
    private schoolSrv: SchoolService,
    private authSrv: AuthService,
    private backendSrv: BackendService,
  ) {}

  toggleSidebar() {
    this.toggledSidebar.emit(true);
  }

  onLogout() {
    this.authSrv.logout();
  }

  ngOnInit() {
    this.schoolSrv.current().subscribe((school: School) => {
      this.school = school;
    });

    this.authSrv.school.subscribe((school) => {
      this.isAuthenticated = !!school;

      if (this.isAuthenticated) {
        this.backendSrv.findAll().subscribe((backends) => {
          this.backends = backends.filter((backend) => backend.isOwnTable);
        });
      }
    });
  }
}
